$(document).ready(function () {
    /**
     * SearchFunction
     */
    var customRenderMenu = function (ul, items) {
        var self = this;
        var currentCategory = "";

        $.each(items, function (index, item) {
            if (item.no_draw) {
                ul.append("<li class='ui-autocomplete-category'>" + item.category + "</li>");
            } else {
                if (item.category != currentCategory) {
                    ul.append("<li class='ui-autocomplete-category'>" + item.category + "</li>");
                    currentCategory = item.category;
                }
                self._renderItemData(ul, item);
            }
        });
    };
    if(document.getElementById("hamburger")) {
        document.getElementById("hamburger").onclick = function toggleMenu() {
            const navToggle = document.getElementsByClassName("toggle");
            for (let i = 0; i < navToggle.length; i++) {
                navToggle.item(i).classList.toggle("hidden");
            }
        };
    }

    var getTreatmentsNameString = function (treatmentsArray, stringMaxLength = 30) {
        if (stringMaxLength < 10 || stringMaxLength > 100) {
            stringMaxLength = 10;
        }

        let treatmentString = "";
        let continueAddingToString = true;

        treatmentsArray.forEach(function (treatmentName, index) {
            if (index > 0 && (treatmentString.length + treatmentName.length + 2) > stringMaxLength) {
                continueAddingToString = false;
                treatmentString += ", ...";
            }

            if (continueAddingToString) {
                if (index > 0) {
                    treatmentString += ", ";
                }

                treatmentString += treatmentName;
            }
        });

        if (treatmentString.length > stringMaxLength) {
            treatmentString = treatmentString.slice(0, stringMaxLength - 3);
            treatmentString += "...";
        }

        return treatmentString;
    };

    $('.login-input').blur(function() {
        var $this = $(this);
        if ($this.val())
            $this.addClass('used');
        else
            $this.removeClass('used');
    });


    // $("#city_select2").select2();

    // $(".select2").select2();
    $(".required_fields_select2").select2({
        multiple: false,
        search: false,
        closeOnSelect: true,
        placeholder: '',
        width: 'resolve'
    });

    $(".locations_select2").select2({
        multiple: true,
        closeOnSelect: false,
        placeholder: 'Välj städer',
        width: 'resolve'
    });

    $('#city_select2_multiple').select2({
        placeholder: "Välj arbetsorter",
    })

    $('.work_city_select2_multiple').select2({
        placeholder: "Välj arbetsorter",
    });

    $('.work_company_select2_multiple').select2({
        placeholder: "Välj företag",
    });

    $('#navbar-search').autocomplete({
        source: '/search/autocomplete',
        position: {collision: "flip"},
        select: function (event, ui) {
            window.location.href = ui.item.url;
        },
        create: function () {
            $(this).data('uiAutocomplete')._renderMenu = customRenderMenu;
        }
    });

    $('#nologin-search').autocomplete({
        source: '/nologin/search-portal',
        position: {collision: "flip"},
        select: function (event, ui) {
            $("#selected-portal-spinner").removeClass('hidden');
            $("#login-select-dropdown").removeClass('hidden');
            window.location.href = ui.item.portal;
        },
    });

    $('#register-search').autocomplete({
        source: '/nologin/search-register',
        position: {collision: "flip"},
        select: function (event, ui) {
            $("#selected-portal-spinner").removeClass('hidden');
            $("#login-select-dropdown").removeClass('hidden');
            window.location.href = ui.item.portal;
        },
    });

    $('.city-select2').select2();

    $('#user-autocomplete').autocomplete({
        source: function (request, response) {
            let scheduleID = $("#manual-booking-modal-schedule-id").val();
            $.getJSON('/customers/autocomplete', {
                term: request.term,
                scheduleID: scheduleID,
                portal_therapist_id: window.Laravel.portal_therapist_id,
            }, response);
        },
        position: {collision: "flip"},
        select: function (e, ui) {
            if (ui && ui.item && ui.item.id) {
                $("#user-id").val(ui.item.id);
            }
        }
    });

    $(".datepicker").datepicker({
        dateFormat: "yy-mm-dd"
    });

    /*$(".timepicker").val("00:00").AnyTime_picker({
        format: "%H:%i",
        labelHour: "timmar",
        labelMinute: "minuter",
        labelTitle: "Välj längd"
    });*/

    $('#treatment_length').datetimepicker({
        locale: 'sv',
        defaultDate: (new Date()).setHours(0, 30, 0, 0),
        format: 'HH:mm'
    });

    $('#time_between_treatments').datetimepicker({
        locale: 'sv',
        defaultDate: (new Date()).setHours(0, 0, 0, 0),
        format: 'HH:mm'
    });

    $('#break_start').datetimepicker({
        locale: 'sv',
        defaultDate: (new Date()).setHours(12, 0, 0, 0),
        format: 'HH:mm'
    });

    $('#break_end').datetimepicker({
        locale: 'sv',
        defaultDate: (new Date()).setHours(12, 30, 0, 0),
        format: 'HH:mm'
    });

    $('#schedule_start').datetimepicker({
        locale: 'sv',
        defaultDate: (new Date()).setHours(12, 0, 0, 0),
        format: 'HH:mm'
    });

    $('#schedule_end').datetimepicker({
        locale: 'sv',
        defaultDate: (new Date()).setHours(12, 30, 0, 0),
        format: 'HH:mm'
    });

    /*$('#day_end').datetimepicker({
        format: 'HH:mm'
    });*/

    $('#day_start').datetimepicker({
        locale: 'sv',
        defaultDate: (new Date()).setHours(8, 0, 0, 0),
        format: 'HH:mm'
    });

    $('#period_start').datetimepicker({
        locale: 'sv',
        defaultDate: new Date(),
        format: 'YYYY-MM-DD'
    });

    $("#period_start").on("change.datetimepicker", function (e) {
        $('#period_end').datetimepicker('minDate', e.date);
    });

    $('#period_end').datetimepicker({
        locale: 'sv',
        defaultDate: new Date(),
        format: 'YYYY-MM-DD'
    });

    $("#period_end").on("change.datetimepicker", function (e) {
        $('#period_start').datetimepicker('maxDate', e.date);
    });

    $('#therapist-autocomplete').autocomplete({
        source: '/therapists/autocomplete',
        minlength: 2,
        autoFocus: true,
        select: function (e, ui) {
            $('#therapist_id').val(ui.item.id);
            $('#therapist_id')[0].dispatchEvent(new CustomEvent('input'));
        }
    });

    $('#fullsearch').autocomplete({
        source: '/search/autocomplete',
        minlength: 4,
        autoFocus: true,
        select: function (e, ui) {
            $('#therapist_id').val(ui.item.id);
        }
    });

    $('#location-autocomplete').autocomplete({
        source: function (request, response) {
            $.getJSON("/locations/autocomplete", {
                    company_id: $('#company_id').val(),
                    term: $('#location-autocomplete').val()
                },
                response);
        },
        minlength: 0,
        autoFocus: true,
        select: function (e, ui) {
            $('#location_id').val(ui.item.id);


        }
    });

    /*
    $("#calendar").fullCalendar({
        locale: 'sv',
        header: {left: 'title', right: false},
        eventLimit: 0,
        dayRender: function (date, cell) {

            var events = countEvents(date);
            if (!events || (events.free == 0 && events.booked == 0)) {
                return;
            }
            else if (events.free == 0) {
                $(cell).addClass("day-with-no-events");
            }
            else if (events.free < 3) {
                $(cell).addClass("day-with-few-events");
            }
            else {
                $(cell).addClass("day-with-many-events");
            }
        },
        eventAfterAllRender: function () {
        },
        dayClick: function (date) {
            window.clickedDate = date;
            window.refreshDailyEventList(date);
        }
    });
    */


    $(".js-back-button").unbind().click(function (event) {
        window.history.back();
    });

    window.refreshDailyEventList = function (date = window.clickedDate) {
        $("#modal-day-events-date").val(date);

        var events = getEvents(date);
        var html = "";
        if (events.length > 0) {
            events.forEach(function (event) {
                if (event.booked) return;
                if(event.iscustomer){
                    if (event.choosable) {
                        html += "<div class='row'> " +
                            "<div class='col-md-2'>" + event.title + "</div>" +
                            "<div class='col-md-3'>" + event.therapist + "</div>" +
                            "<div class='col-md-3'>" + getTreatmentsNameString(event.treatmentNames) + "</div>" +
                            "<div class='col-md-4 text-right'><button data-id='"
                            + event.id + "' class='show-calendar-modal btn btn-primary btn-sm'>Reservera</button></div>" +
                            "</div>";
                    } else {
                        html += "<div class='row'> " +
                            "<div class='col-md-2'>" + event.title + "</div>" +
                            "<div class='col-md-3'>" + event.therapist + "</div>" +
                            "<div class='col-md-3'>" + getTreatmentsNameString(event.treatmentNames) + "</div>" +
                            "<div class='col-md-4 text-right'><button data-schedule-id='"
                            + event.treatment + "' data-id='" + event.id
                            + "' class='hide-calendar-modal btn btn-primary btn-sm'>Reservera</button></div>" +
                            "</div>";
                    }
                } else {
                    html += "<div class='row'> " +
                        "<div class='col-md-2'>" + event.title + "</div>" +
                        "<div class='col-md-3'>" + event.therapist + "</div>" +
                        "<div class='col-md-3'>" + getTreatmentsNameString(event.treatmentNames) + "</div>" +
                        "<div class='col-md-4 text-right'>" +
                        "<button class='btn btn-primary btn-sm' disabled>Reservera</button></div>" +
                        "</div>";
                }
            });
        }
        else {
            html = null;
        }
        if (!html) {
            html = "<p>Det finns inga lediga tider.</p>";
        }
        moment.locale('sv');
        document.getElementById("dayeventsdate").innerHTML = 'Dagsevent ' + date.format("YY-MM-DD");
        $("#calendar-event-list").html(html);
        $("#modaldayevents").modal("show");
    };

    /*
    $("#calendar_prev_day").click(function () {
        $('#calendar').fullCalendar('prev');
    });

    $("#calendar_today").click(function () {
        $('#calendar').fullCalendar('today');
    });

    $("#calendar_next_day").click(function () {
        $('#calendar').fullCalendar('next');
    });
    */


    $('.calendar_treatments').change(function () {
        //updateCalendarEvents();
    });

    $('.calendar_therapists').change(function () {
        //updateCalendarEvents();
    });

    $("body").on('click', '.show-calendar-modal', function () {
        $.get("/book/" + $(this).data("id") + "/modal").then(function (data) {
            $("#calendar-modal-content").html(data);
            $("#modalconfirm").modal("show");
        });
    });

    $("body").on('click', '.hide-calendar-modal', function () {
        var button = $(this);
        $.post("/reservations/reserve", {
            _token: window.Laravel.csrfToken,
            treatment_id: $(this).data("schedule-id"),
            id: $(this).data("id")
        }).done(function (data) {
            // TODO: Handle updating of available schedules with some kind of refresh
            if(data[0]) {
                // Remove row if reserved
                button.closest('.row').remove();
                window.flash(data[1], 'success');
            } else {
                window.flash(data[1], 'warning');
            }
        });
    });

    window.removeLockRow = function (caller) {
        let self = $(caller);
        let row = self.closest(".lock-row");
        let parent = row.closest(".lock-row-container");
        let domainRowsCount = parent.children(".lock-row").length;
        let input = row.children(".lock-input").first();

        if (domainRowsCount != 1) {
            row.remove();
        } else {
            input.val("");
        }
    };

    $("#add-lock-email-field").unbind().click(function (event) {
        let container = $("#lock-row-container");
        let newRow = `
            <div class="input-group lock-row">
                <div class="input-group-prepend">
                    <span class="input-group-text">@</span>
                </div>
                <input type="text" name="lock_email_domain[]" class="form-control lock-input" value="">
                <div class="input-group-append">
                    <button type="button" class="btn btn-danger" onclick="removeLockRow(this)"><i class="fa fa-minus"></i></button>
                </div>
            </div>
        `;


        container.append(newRow);
    });

    window.addLockRow = function () {

    }

    /*
    window.updateCalendarEvents = function (shouldRefreshDailyEventList = false) {
        var start = $('#calendar').fullCalendar('getView').start / 1000;
        var end = $('#calendar').fullCalendar('getView').end / 1000;

        var therapist_ids = [];
        var treatment_ids = [];
        $(".calendar_treatments").each(function (key, value) {
            if ($(value).prop("checked")) {
                treatment_ids.push($(value).val());
            }
        });
        $(".calendar_therapists").each(function (key, value) {
            if ($(value).prop("checked")) {
                therapist_ids.push($(value).val());
            }
        });
        if (!isNaN(start)) {
            $.post("/book/filterevents", {
                _token: window.Laravel.csrfToken,
                start: start,
                end: end,
                therapist_ids: therapist_ids,
                treatment_ids: treatment_ids
            }).done(function (data) {
                $('#calendar').fullCalendar('removeEventSources');
                $('#calendar').fullCalendar('removeEvents');
                $('#calendar').fullCalendar('addEventSource', data);
                $('#calendar').fullCalendar('prev');
                $('#calendar').fullCalendar('next');

                if (shouldRefreshDailyEventList) {
                    window.refreshDailyEventList();
                }
            });
        }
    };
     */

    window.calculateCancellationLimit = function (schedule, customer) {
        let company = customer.company;
        if (company.cancel_booking_rule_type == 1) {
            // Unbook before x days, time y
            let now = moment(schedule.start);
            let cancellationHoursArray = company.cancel_booking_before_time.split(':');
            now.add(company.cancel_booking_before_days, 'd');
            now.set({
                hour: cancellationHoursArray[0],
                minute: cancellationHoursArray[1],
                second: 0,
                millisecond: 0,
            });
            return now;
        } else {
            // Unbook before x hours
            let now = moment(schedule.start);
            now = now.add(company.cancel_booking_before_hours, 'h');
            return now;
        }
    }

    window.getCancellationLimitDateText = function (limit) {
        return moment(limit).subtract(2, 'days').format('YYYY-MM-DD');
    };

    window.getCancellationLimitTimeText = function (limit) {
        return moment(limit).format('HH:mm');
    };

    window.getDateTime = function (dateString, dateStringEnd) {
        return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
    },

    function countEvents(date) {
        var events = getEvents(date);
        var free = 0;
        var booked = 0;

        if (events.length < 1) return null;
        else {
            events.forEach(function (event) {
                if (event.booked) booked++;
                else free++
            });
        }
        return {free: free, booked: booked};
    }

    function getEvents(date) {
        var eventsources = $("#calendar").fullCalendar('getEventSources');
        var start = date.unix() * 1000;
        var end = start + 86400000;
        if (eventsources.length < 1) return [];
        var events = [];
        eventsources[0].rawEventDefs.forEach(function (event) {
            if (event.start > start && event.end < end) {
                events.push(event);
            }
        });

        return events;
    }

    /**
     *  Returns an array with the current visible dates on the calendar
     *
     * @param startDate
     * @param endDate
     * @returns {Array}
     */
    function enumerateDaysBetweenDates(startDate, endDate) {
        var dates = [];

        var currDate = startDate.clone().startOf('day');
        var lastDate = endDate.clone().startOf('day');

        while (currDate.add(1, 'days').diff(lastDate) < 0) {
            dates.push(currDate.clone().toDate());
        }
        return dates;
    };
    //updateCalendarEvents();
});
